import { useState } from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Switch } from '@/atoms/Switch';
import { TextField } from '@/atoms/TextField';
import { FormField } from '@/molecules/FormField';
import { FormSection } from '@/organisms/FormSection';
import { Button } from '@/atoms/Button';
import { SettingsLayout, type SettingsSection } from '@/templates/SettingsLayout';

/**
 * SettingsExample
 * Example settings page using SettingsLayout + FormSection + FormField.
 */
const sections: SettingsSection[] = [
  { id: 'general', label: 'General' },
  { id: 'notifications', label: 'Notifications' },
  { id: 'integrations', label: 'Integrations' },
];

export function SettingsExample() {
  const [active, setActive] = useState('general');
  return (
    <Box sx={{ p: 3 }}>
      <SettingsLayout sections={sections} activeId={active} onSelect={setActive}>
        <FormSection title="Organization" description="Basic account details.">
          <FormField label="Organization name" htmlFor="org">
            <TextField id="org" defaultValue="AiStrike" />
          </FormField>
          <FormField label="Primary contact" htmlFor="contact">
            <TextField id="contact" defaultValue="security@example.com" />
          </FormField>
        </FormSection>
        <FormSection title="Preferences" divider>
          <FormControlLabel control={<Switch defaultChecked />} label="Email me weekly posture reports" />
          <FormControlLabel control={<Switch />} label="Auto-remediate low severity findings" />
        </FormSection>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button variant="ghost">Cancel</Button>
          <Button variant="primary">Save changes</Button>
        </Box>
      </SettingsLayout>
    </Box>
  );
}
